import React from "react";
import xtLogo from "../assets/xt-logo.png";

export default function XtLogo({ className = "h-16 w-16", alt = "X-Translator" }) {
  return <img src={xtLogo} alt={alt} className={`object-contain ${className}`} />;
}
